import { Injectable } from "@angular/core";
import { createStore, withProps } from "@ngneat/elf";
import { Checklist, Response } from "../checklist.interface";
import { localStorageStrategy, persistState } from "@ngneat/elf-persist-state";
import { debounceTime } from "rxjs";

export function createInitialState(): ChecklistProgressState {
	return {
		checklist: undefined,
		currentPageIndex: 0,
		responses: [],
	};
}

const checklistProgressStateStore = createStore(
	{ name: "checklist-progress-state" },
	withProps<ChecklistProgressState>(createInitialState()),
);

@Injectable({ providedIn: "root" })
export class ChecklistProgressStateStore {
	constructor() {
		persistState(checklistProgressStateStore, {
			storage: localStorageStrategy,
			source: () => checklistProgressStateStore.pipe(debounceTime(1000)),
		});
	}

	public store = checklistProgressStateStore;

	reset = () => checklistProgressStateStore.reset();
}

export interface ChecklistProgressState {
	checklist: Checklist;
	currentPageIndex: number;
	responses: Response[];
}
